define('helpers/FormatHelper', [

], function(){

    var formatCurrency = function( currency, value ) {
        var currencyString = "";
        value = parseFloat( value );

        switch( currency ) {
            case 'EUR':
                currencyString = value.toFixed(2) + ' €';
                break;

            case 'GBP':
                currencyString = '£ ' + value.toFixed(2);
                break;

            case 'CNY':
            case 'JPY':
                currencyString = '￥' + value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                break;

            case 'USD':
                currencyString = '$' + value.toFixed(2);
                break;
        }

        return currencyString;
    };

    return {
        formatCurrency: formatCurrency
    };
});